import React, { Component, useContext } from "react";
import { UserOutlined } from "@ant-design/icons";

import authClient from "../api/authClient";
import AuthContext from "../auth/context";
import { Avatar } from "antd";

function TopNavBar() {
  const authContext = useContext(AuthContext);

  const handleLogout = () => {
    localStorage.removeItem("currentUser");
    authContext.setUser(null);
    authClient.logout();
  };

  return (
    <div className="navbar-custom">
      <ul className="list-unstyled topbar-right-menu float-right mb-0">
        <li className="dropdown notification-list">
          <a
            className="nav-link dropdown-toggle arrow-none"
            data-toggle="dropdown"
            href="#"
            role="button"
            aria-haspopup="false"
            aria-expanded="false"
          >
            <i className="dripicons-bell noti-icon"></i>
            <span className="noti-icon-badge d-none"></span>
          </a>
          <div className="dropdown-menu dropdown-menu-right dropdown-menu-animated dropdown-lg d-none">
            <div className="dropdown-item noti-title">
              <h5 className="m-0">
                <span className="float-right">
                  <a className="text-dark">
                    <small>Clear All</small>
                  </a>
                </span>
                Notification
              </h5>
            </div>

            <div style={{ maxHeight: "230px" }} data-simplebar>
              <a className="dropdown-item notify-item">
                <div className="notify-icon bg-primary">
                  <i className="mdi mdi-comment-account-outline"></i>
                </div>
                <p className="notify-details">
                  Caleb Flakelar commented on Admin
                  <small className="text-muted">1 min ago</small>
                </p>
              </a>

              <a className="dropdown-item notify-item">
                <div className="notify-icon bg-info">
                  <i className="mdi mdi-account-plus"></i>
                </div>
                <p className="notify-details">
                  New user registered.
                  <small className="text-muted">5 hours ago</small>
                </p>
              </a>

              <a className="dropdown-item notify-item">
                <div className="notify-icon">
                  <img
                    src="assets/images/users/avatar-2.jpg"
                    className="img-fluid rounded-circle"
                    alt=""
                  />{" "}
                </div>
                <p className="notify-details">Cristina Pride</p>
                <p className="text-muted mb-0 user-msg">
                  <small>Hi, How are you? What about our next meeting</small>
                </p>
              </a>

              <a className="dropdown-item notify-item">
                <div className="notify-icon bg-primary">
                  <i className="mdi mdi-comment-account-outline"></i>
                </div>
                <p className="notify-details">
                  Caleb Flakelar commented on Admin
                  <small className="text-muted">4 days ago</small>
                </p>
              </a>

              <a className="dropdown-item notify-item">
                <div className="notify-icon">
                  <img
                    src="assets/images/users/avatar-4.jpg"
                    className="img-fluid rounded-circle"
                    alt=""
                  />{" "}
                </div>
                <p className="notify-details">Karen Robinson</p>
                <p className="text-muted mb-0 user-msg">
                  <small>Wow ! this admin looks good and awesome design</small>
                </p>
              </a>

              <a className="dropdown-item notify-item">
                <div className="notify-icon bg-info">
                  <i className="mdi mdi-heart"></i>
                </div>
                <p className="notify-details">
                  Carlos Crouch liked
                  <b>Admin</b>
                  <small className="text-muted">13 days ago</small>
                </p>
              </a>
            </div>

            <a className="dropdown-item text-center text-primary notify-item notify-all">
              View All
            </a>
          </div>
        </li>

        <li className="dropdown notification-list d-none  ">
          <a
            className="nav-link dropdown-toggle arrow-none"
            data-toggle="dropdown"
            href="#"
            role="button"
            aria-haspopup="false"
            aria-expanded="false"
          >
            <i className="dripicons-view-apps noti-icon"></i>
          </a>
          <div className="dropdown-menu dropdown-menu-right dropdown-menu-animated dropdown-lg p-0">
            <div className="p-2">
              <div className="row no-gutters">
                <div className="col">
                  <a className="dropdown-icon-item" href="#">
                    <img src="assets/images/brands/slack.png" alt="slack" />
                    <span>Slack</span>
                  </a>
                </div>
                <div className="col">
                  <a className="dropdown-icon-item" href="#">
                    <img src="assets/images/brands/github.png" alt="Github" />
                    <span>GitHub</span>
                  </a>
                </div>
                <div className="col">
                  <a className="dropdown-icon-item" href="#">
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/brands/dribbble.png"
                      }
                      alt="dribbble"
                    />
                    <span>Dribbble</span>
                  </a>
                </div>
              </div>

              <div className="row no-gutters">
                <div className="col">
                  <a className="dropdown-icon-item" href="#">
                    <img
                      src="assets/images/brands/bitbucket.png"
                      alt="bitbucket"
                    />
                    <span>Bitbucket</span>
                  </a>
                </div>
                <div className="col">
                  <a className="dropdown-icon-item" href="#">
                    <img src="assets/images/brands/dropbox.png" alt="dropbox" />
                    <span>Dropbox</span>
                  </a>
                </div>
                <div className="col">
                  <a className="dropdown-icon-item" href="#">
                    <img src="assets/images/brands/g-suite.png" alt="G Suite" />
                    <span>G Suite</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </li>

        <li className="notification-list d-none">
          <a className="nav-link right-bar-toggle">
            <i className="dripicons-gear noti-icon"></i>
          </a>
        </li>

        <li className="dropdown notification-list ">
          <a
            className="nav-link dropdown-toggle nav-user arrow-none mr-0"
            data-toggle="dropdown"
            href="#"
            role="button"
            aria-haspopup="false"
            aria-expanded="false"
          >
            <span className="account-user-avatar">
              <Avatar icon={<UserOutlined />} />
            </span>
            <span>
              <span className="account-user-name">
                {authContext.user.prenom} {authContext.user.nom}
              </span>
              <span className="account-position"></span>
            </span>
          </a>
          <div className="dropdown-menu dropdown-menu-right dropdown-menu-animated topbar-dropdown-menu profile-dropdown">
            <div className=" dropdown-header noti-title">
              <h6 className="text-overflow m-0">Welcome !</h6>
            </div>

            <a className="dropdown-item notify-item disabled">
              <i className="mdi mdi-account-circle mr-1"></i>
              <span>Mon compte</span>
            </a>

            <a className="dropdown-item notify-item" onClick={handleLogout}>
              <i className="mdi mdi-logout mr-1"></i>
              <span>Déconnexion</span>
            </a>
          </div>
        </li>
      </ul>
      <button className="button-menu-mobile open-left disable-btn">
        <i className="mdi mdi-menu"></i>
      </button>
    </div>
  );
}

export default TopNavBar;
